import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Subfee.Find.IRequest;
type Response = Api.Core.Subfee.Find.IResponse;
type Headers = Api.Core.Subfee.Find.IHeaders;
const url = '/api/ProductManagement/Subfee/:id';
export default async function subfeeFindApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
